import { ValueParser } from "./value-parser";

export class AttributeParser {
  constructor(protected element: Element) {}

  string(name: string): string | undefined;
  string(name: string, defaultValue: string): string;
  string(name: string, defaultValue?: string) {
    return ValueParser.string(this.element.getAttribute(name), defaultValue);
  }

  number(name: string): number | undefined;
  number(name: string, defaultValue: number): number;
  number(name: string, defaultValue?: number) {
    return ValueParser.number(this.element.getAttribute(name), defaultValue);
  }

  boolean(name: string): boolean;
  boolean(name: string, defaultValue: boolean): boolean;
  boolean(name: string, defaultValue?: boolean) {
    return ValueParser.boolean(this.element.getAttribute(name), defaultValue);
  }

  literal<T extends string>(
    name: string,
    allowedValues: T[],
    defaultValue: T,
  ): T {
    return ValueParser.literal(
      this.element.getAttribute(name),
      allowedValues,
      defaultValue,
    );
  }
}
